import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { DISTRIBUTION_EFFICIENCY_AGGREGATED_STATISTICS_GET } from 'api/query-keys';
import type { TGetDistributionEfficiencyAggregatedStatisticsRes } from 'api/swagger';
import type { IDistributionEfficiencyFilter } from 'shared/stores/use-distribution-efficiency-filters';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  filters: IDistributionEfficiencyFilter;
}

export const useGetDistributionEfficiencyAggregatedStatistics = ({ filters }: IParams) => {
  const qs = new URLSearchParams();
  setFiltersToQs<IDistributionEfficiencyFilter>(qs, filters);

  return useQuery({
    queryKey: [DISTRIBUTION_EFFICIENCY_AGGREGATED_STATISTICS_GET, { filters }],
    queryFn: async () => {
      const { data } = await http.get<TGetDistributionEfficiencyAggregatedStatisticsRes>(
        `/v1/statistics/cargo-time-aggregated?${qs.toString()}`,
      );
      return data;
    },
    enabled: Boolean(filters.warehouseId),
    retry: false,
    refetchOnWindowFocus: false,
  });
};
